export const FETCH_REPORTSLIST_REQUEST = 'FETCH_REPORTSLIST_REQUEST';
export const FETCH_REPORTSLIST_FAILURE = 'FETCH_REPORTSLIST_FAILURE';
export const FETCH_REPORTSLIST_SUCCESS = 'FETCH_REPORTSLIST_SUCCESS';
export const FETCH_REPORT_REQUEST = 'FETCH_REPORT_REQUEST';
export const FETCH_REPORT_FAILURE = 'FETCH_REPORT_FAILURE';
export const FETCH_REPORT_SUCCESS = 'FETCH_REPORT_SUCCESS';
